import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import MobileHeader from './components/MobileHeader';
import MobileSidebar from './components/MobileSidebar';
import './css/AdminLayout.css';
// Import the custom CSS
import '../css/admin-crud.css';

const AdminLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const location = useLocation();

  // Close mobile sidebar on route change
  useEffect(() => {
    setMobileSidebarOpen(false);
  }, [location.pathname]);

  const toggleSidebar = () => setSidebarCollapsed(!sidebarCollapsed);
  const toggleMobileSidebar = () => setMobileSidebarOpen(!mobileSidebarOpen);

  return (
    <div className="admin-dashboard-modern">
      {/* Desktop Sidebar - Hidden on mobile */}
      <div className="desktop-only">
        <Sidebar 
          collapsed={sidebarCollapsed} 
          onToggle={toggleSidebar} 
        />
      </div>

      {/* Mobile Header - Visible only on mobile */}
      <MobileHeader onMenuClick={toggleMobileSidebar} />

      {/* Mobile Sidebar - Overlay */}
      <MobileSidebar 
        show={mobileSidebarOpen} 
        onHide={toggleMobileSidebar} 
      />

      {/* Main Content */}
      <div className={`main-content-modern ${sidebarCollapsed ? 'collapsed' : ''}`}>
        <Container fluid className="px-3 px-md-4 py-3 py-md-4">
          <Outlet />
        </Container>
      </div>
    </div>
  );
};

export default AdminLayout;